import { Fragment } from 'react'
import { NextSeo } from 'next-seo'
import { useTranslation } from 'next-i18next'
import { Box } from '@chakra-ui/react'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import Form from '@/features/landing/templates/Form'
import Blogs from '@/features/landing/templates/Blogs'
import Contact from '@/features/landing/templates/Contact'
import OurTrustingClient from '@/features/landing/templates/OurTrustingClient'

import Hero from '@/features/services/templates/Hero'
import ServiceInfo from '@/features/services/templates/ServiceInfo'
import { HandoutBanner } from '@/features/resources/components/Banner'
import { logEvent } from '@/lib/gtm'

import ServiceCatalog from '@/features/services/components/ServiceCatalog'

import { ServicePageProps } from '@/features/services/types'

import {
  useMeta,
  useHeroData,
  useServiceInfoData,
  useServiceCatalogData,
} from '@/features/services/constants/dpo'

function DPOPage({ blogs }: ServicePageProps): React.ReactElement {
  const { t } = useTranslation('services')

  const META = useMeta()
  const HERO = useHeroData()
  const INFO = useServiceInfoData()
  const CATALOG_ITEMS = useServiceCatalogData()

  return (
    <Fragment>
      <AlternateLink />
      <NextSeo
        title={META.title}
        description={META.description}
        openGraph={{
          title: META.og.title,
          description: META.og.description,
          images: [
            {
              url: META.og.image.url,
              width: 1200,
              height: 630,
              alt: META.og.title,
            },
          ],
        }}
      />
      <NavigationBar />
      <Hero {...HERO} />
      <ServiceInfo {...INFO} />
      <Box id="service-catalog">
        <ServiceCatalog
          title={t('dpo.catalog.title')}
          items={CATALOG_ITEMS}
        />
      </Box>
      <OurTrustingClient />
      <Box sx={{ w: 'full', bg: 'gray.50' }}>
        <HandoutBanner
          onClickDownload={() => {
            logEvent({
              ga: {
                category: 'DPO',
                action: 'Download handout',
                label: 'handoutSection',
              },
            })
          }}
        />
      </Box>
      <Box id="contact-form">
        <Form />
      </Box>
      {blogs && <Blogs blogs={blogs} />}
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default DPOPage
